
export enum ConsumerType {
  Unknown = 0,
  Prepaid = 1,
  Postpaid = 2,
}

export enum PendingStatus {
  Unknown = 0,
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export enum ResidencyStatus {
  Unknown = 0,
  Tenant = 1,
  Landlord = 2,
}


export interface CustomerEnergyAccountRequest {
  meterNumber?: string | null;
  accountNumber?: string | null;
  utilityId: string;
  consumerType?: string;
  preferRemoteTokenLoad?: boolean;
  residencyStatus?: string;
  nin?: string;
  saveAsPending?: boolean;
}

export interface EnergyProfile {
  id: string;
  isDeleted: boolean;
  userId: string;
  consumerType: ConsumerType;
  meterNumber: string;
  accountNumber: string;
  meterAddress: string;
  utilityId: string;
  utility: Utility;
  pendingStatus: PendingStatus | null;
  createdAt: string;
  updatedAt: string;
  teamId: string;
  preferRemoteTokenLoad: boolean | null;
  isNinVerified: boolean;
  residencyStatus: ResidencyStatus | null;
  nin: string | null;
  isNinPhoneNumberVerified: boolean;
}

export interface Utility {
  id: string;
  name: string;
  utilityCode: number;
  countryId: number;
}

export interface CustomerMeterNumber {
  id: string;
  name: string;
  meterNumber: string;
  accountNumber: string;
  consumerType: ConsumerType;
  residencyStatus: ResidencyStatus | null;
  preferRemoteTokenLoad: boolean;
  isActive: boolean;
  pendingStatus: number | null;
}

// Form data interface (for react-hook-form)
export interface EnergyProfileFormData {
  meterNumber: string;
  accountNumber: string;
  utilityId: string;
  meterAddress: string;
  consumerType: ConsumerType; // Use enum in form
}

// Helper function to convert form data to API payload
export const toCustomerEnergyAccountRequest = (
  formData: EnergyProfileFormData
): CustomerEnergyAccountRequest => {
  return {
    meterNumber: formData.meterNumber,
    accountNumber: formData.accountNumber,
    utilityId: formData.utilityId,
    consumerType: formData.consumerType.toString(),
  };
};

// Helper function to convert API response to form data
export const toEnergyProfileFormData = (
  profile: EnergyProfile
): EnergyProfileFormData => {
  return {
    meterNumber: profile.meterNumber,
    accountNumber: profile.accountNumber,
    utilityId: profile.utilityId,
    meterAddress: profile.meterAddress,
    consumerType: profile.consumerType,
  };
};

// Utility select options
export interface UtilityOption {
  value: string;
  label: string;
}

// Consumer type select options
export const consumerTypeOptions = [
  { value: ConsumerType.Prepaid.toString(), label: 'Prepaid' },
  { value: ConsumerType.Postpaid.toString(), label: 'Postpaid' },
];

// Helper to get consumer type label
export const getConsumerTypeLabel = (type: ConsumerType | string): string => {
  const typeNum = typeof type === 'string' ? parseInt(type) : type;
  switch (typeNum) {
    case ConsumerType.Prepaid:
      return 'Prepaid';
    case ConsumerType.Postpaid:
      return 'Postpaid';
    default:
      return 'Unknown';
  }
};

export interface VerifyNinRequest {
  nin: string;
  residencyStatus: string;
  consumerType: string;
  utilityId: string;
  meterNumber?: string;
  accountNumber?: string;
}